module.exports = __webpack_public_path__ + "assets/24a32f4d41aefaf0c5cadddf737ad093.mp4";